import React from "react";
import seaImage from "../images/sea.png";
import archImage from "../images/sunset.png";
import houseImage from "../images/houses.png";

function AboutImages() {
	return (
		<>
			<img
				src={seaImage}
				alt="Sea View"
			/>

			<img
				src={archImage}
				alt="Sunset Arch View"
			/>
			<img
				src={houseImage}
				alt="House View"
			/>
		</>
	);
}

export default AboutImages;
